import { HeaderGroup } from "react-table"
import { TableHeadCell } from "../TableHeadCell"

type Props<T extends {}> = {
  column: HeaderGroup<T>
}

export const TableHeadCellRenderer = <T extends {}>({ column }: Props<T>) => {
  if (typeof column.Header === `string` || typeof column.Header === `number`) {
    return <TableHeadCell header={column.Header} />
  }
  return <>{column.render(`Header`)}</>
}
